<section class="footer  bg-[var(--footer-light-coler)] dark:bg-[var(--footer-dark-coler)] ">
  <div class="flex flex-col lg:flex-row justify-between p-4">

    <div class="flex flex-col lg:flex-row">
      <div class="logo flex flex-col items-center p-10 text-center">
        <img src="/logo.ico" alt="logo">
        <h3 class="mt-2 text-[var(--auth-dark-color)] text-xl">Rose E-Commerce App</h3>
        <p class="text-gray-300">All rights reserved | 2025</p>
      </div>

      <div class="links p-4">
        <h3 class="mt-3 text-[var(--auth-dark-color)] text-xl">Discover our website</h3>
        @for(item of items ; track $index){
            <a [routerLink]="item" class="block text-gray-300">{{item}}</a>
        }
      </div>
    </div>

    <div class="p-6 mt-6 lg:mt-0">
      <h2 class="text-[var(--auth-dark-color)] text-xl">Get <span class="text-gray-300">20%</span> Off Discount Coupon</h2>
      <p class="mt-0 mb-4 text-sm text-gray-500">By subscribing to our newsletter</p>

      <div class="relative w-full max-w-sm">
        <input 
          type="email" 
          placeholder="Enter your email"
          class="w-full border border-[#52525B] text-[#A1A1AA] rounded-3xl py-2 pr-28 pl-4 bg-[#52525B]"
        />
        <button 
          class="absolute right-0 inset-y-0 my-auto bg-[#FBEAEA] dark:bg-[#FFA3B9] text-[#741C21] px-4 rounded-3xl"
        >
          Subscribe <i class="pi pi-arrow-right ml-2"></i>
        </button>
      </div>
    </div>

  </div>
</section>



